import { FC, useCallback } from "react";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { infrastructureArchitectureSelectedAccountSelector } from "@/store/infrastructure-architecture/selectors/infrastructureArchitectureSelectedAccountSelector";
import { AccountSelect } from "@/components/common/account-select/AccountSelect";
import { allAccountsSelectOptionsSelector } from "@/store/accounts/selectors/all-providers/allAccountsSelectOptionsSelector";
import { setInfrastructureArchitectureRequestData } from "@/store/infrastructure-architecture/infrastructureArchitectureSlice";

export const InfrastructureArchitectureAccountSelect: FC = () => {
  const dispatch = useAppDispatch();
  const selectedAccountId = useAppSelector(
    infrastructureArchitectureSelectedAccountSelector,
  );
  const groupedAllAccounts = useAppSelector(
    allAccountsSelectOptionsSelector,
  ).filter(({ accountType }) => accountType === "aws");

  const changeHandler = useCallback(
    (value: string[]) => {
      dispatch(
        setInfrastructureArchitectureRequestData({
          selectedAccountId: value?.at(0),
        }),
      );
    },
    [dispatch],
  );

  return (
    <AccountSelect
      singleSelect
      wrapperVariant="dropdown"
      onChange={changeHandler}
      options={groupedAllAccounts}
      selectedValue={selectedAccountId ? [selectedAccountId] : []}
    />
  );
};
